module.exports = __webpack_public_path__ + "static/media/leader.d7d29579.png";